<template>
  <div class="home-view container" role="main">
    <Breadcrumbs></Breadcrumbs>
    <Wizzard current-page="voucher"></Wizzard>
    <h1 class="d-flex">Emissão de Certificado</h1>
    <span class="span-tip d-flex mb-3">
      Para emitir um Certificado a partir de um Bird ID, será necessário digitar
      o código do Voucher do Certificado adquirido.
    </span>
    <div class="d-flex row col-12 me-0 ms-0">
      <div class="col-12 col-md-6 input-voucher-column">
        <span class="d-flex">Nº Voucher/Pedido*</span>
        <Input
          v-model="voucher"
          class="input-voucher mt-2 w-100"
          icon="tag"
          placeholder="Digite o código do Voucher/Pedido"
          :error-log="error"
          :is-disabled="isInputDisabled"
        />
        <div v-if="showProductSelection" class="mt-4 text-start">
          <span class="d-flex mb-2"
            >Qual Certificado deseja emitir agora? *</span
          >

          <Selectable
            v-model="selectedProduct"
            :options="productSelectOptions"
            icon="shield"
            :is-required="true"
            :error-log="error"
            placeholder="Selecione um certificado"
          />
        </div>
        <div class="d-flex flex-row justify-content-end">
          <button
            class="btn-next-page btn btn-primary d-flex justify-content-around mt-2 align-self-end"
            type="button"
            :class="[!isValid ? 'btn-secondary' : 'btn-primary']"
            :disabled="!isValid"
            @click="handleProceed"
          >
            <div
              class="d-flex flex-row justify-content-center align-items-center gap-2"
            >
              <span>{{ showProductSelection ? 'Avançar' : 'Validar' }}</span>
              <Icon
                :name="
                  showProductSelection ? 'arrow-right' : 'magnifying-glass'
                "
              ></Icon>
            </div>
          </button>
        </div>
      </div>
      <div class="col-12 col-md-6 accordion-voucher-column pb-md-5z">
        <div id="AccordionWhatsVoucher" class="accordion">
          <div class="accordion-item">
            <div id="AccordionQuestionVoucher" class="accordion-header">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#AccordionAnswerVoucher"
                aria-controls="AccordionAnswerVoucher"
              >
                O que é um Voucher?
              </button>
            </div>
            <div
              id="AccordionAnswerVoucher"
              class="accordion-collapse collapse"
              aria-labelledby="AccordionQuestionVoucher"
              data-bs-parent="#AccordionWhatsVoucher"
            >
              <div class="accordion-body">
                <p class="m-0 text-start">
                  O voucher é um código que você recebe de uma empresa
                  <br />para emitir seu Certificado <br />Digital, como por
                  exemplo, seu contador ou a empresa onde você trabalha. O
                  voucher <br />tem 12 caracteres e é um misto de números e
                  letras. Ex: 001c70fxxxxx.
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div
              id="AccordionQuestionWhereRequestNumber"
              class="accordion-header"
            >
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#AccordionAnswerWhereRequestNumber"
                aria-expanded="false"
                aria-controls="AccordionAnswerWhereRequestNumber"
              >
                Onde encontro o número do Pedido?
              </button>
            </div>
            <div
              id="AccordionAnswerWhereRequestNumber"
              class="accordion-collapse collapse"
              aria-labelledby="AccordionQuestionWhereRequestNumber"
              data-bs-parent="#AccordionWhatsVoucher"
            >
              <div class="accordion-body">
                <p class="m-0 text-start">
                  O número do pedido é um número que você recebe assim <br />que
                  efetua uma compra em <br />nosso e-commerce. Este número vai
                  por e-mail junto com as informações de compra <br />e
                  geralmente está contido também no assunto do e-mail.
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <div id="AccordionQuestionDontHaveVoucher" class="accordion-header">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#AccordionAnswerDontHaveVoucher"
                aria-expanded="false"
                aria-controls="AccordionAnswerDontHaveVoucher"
              >
                Não tenho um Voucher Nº do Pedido, e agora?
              </button>
            </div>
            <div
              id="AccordionAnswerDontHaveVoucher"
              class="accordion-collapse collapse"
              aria-labelledby="AccordionQuestionDontHaveVoucher"
              data-bs-parent="#AccordionWhatsVoucher"
            >
              <div class="accordion-body">
                <p class="m-0 text-start">
                  Ainda não tem um voucher ou um número de pedido?
                </p>
                <p class="m-0 text-start">
                  Entre em contato conosco e adquira!
                </p>
                <p class="m-0 text-start">{{ arData.foneAR }}</p>
                <p class="m-0 text-start">
                  {{
                    arData.siteAR
                      .replace('https://', '')
                      .replace('http:/', '')
                      .replace('/', '')
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalRFB
      ref="modalRfbRef"
      :create-solicitation="createSolicitation"
      :request="model"
    />
    <ModalRFBError ref="modalRfbRefError" />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  import loginController, {
    VoucherParam,
  } from '@/infra/BirdId/controllers/login.controller'
  import { mapActions, mapState } from 'pinia'
  import { useMainStore } from '@/store/Pinia/useMain.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useAR } from '@/store/Pinia/useAR.store'
  import { useModalLoading } from '@/store/Pinia/useModalLoading.store'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { useRouteBirdId } from '@/store/Pinia/useRouteBirdId.store'
  import saveDataVoucher from '@/utils/saveDataVoucher'
  import ModalRFB from '@/components/templates/ModalRFB.vue'
  import ModalRFBError from '@/components/templates/ModalRFBError.vue'
  import { useOeRecaptcha } from '@/composables/useOeRecaptcha'
  import Selectable from '@/components/Atoms/Selectable.vue'

  export default defineComponent({
    name: 'VoucherView',
    components: {
      ModalRFB,
      ModalRFBError,
      Selectable,
    },
    setup() {
      return {
        oeRecaptcha: useOeRecaptcha(),
      }
    },
    data: () => ({
      voucher: '',
      error: '',
      model: {
        token: {
          sessionData: '',
          sessionId: '',
        },
        arsubdomain: '',
        voucher: '',
        cnpj: '',
        produtos: [],
        hasRfb: false,
      } as VoucherParam,
      productList: [] as Array<any> as any,
      selectedProduct: '' as any,
      hasProductRFB: false,
      isInputDisabled: false,
      voucherValidated: false,
    }),
    watch: {
      voucher(curr, prev) {
        if (curr !== prev) {
          this.voucherValidated = false
          this.productList = []
          this.selectedProduct = ''

          if (curr.length > 0 && this.error) {
            this.error = ''
          }
        }
      },
    },
    errorReq: '',
    computed: {
      ...mapState(useMainStore, ['unidade']),
      ...mapState(useSolicitation, ['getCessToken']),
      ...mapState(useAR, ['arData']),
      isValid() {
        const isInsertVaultOnly =
          !this.showProductSelection && this.voucher.trim().length >= 1

        if (isInsertVaultOnly) {
          return true
        }

        return (
          !!this.voucher &&
          !this.error &&
          !!this.selectedProduct &&
          !this.isInputDisabled
        )
      },
      productSelectOptions(): Array<any> {
        return this.productList
          .map((product: any) => ({
            id: product.idproduto || product.idProduto,
            label: product.nome,
            value: product.idproduto || product.idProduto,
          }))
          .filter((item: any) => !!item.id)
      },
      showProductSelection(): boolean {
        return this.voucherValidated && this.productSelectOptions.length > 1
      },
    },
    methods: {
      ...mapActions(useDynamicForms, ['setMunicipios', 'setFormData']),
      ...mapActions(useSolicitation, ['saveDataSolicitation', 'setIsRFB']),
      ...mapActions(useModalLoading, ['setIsLoading']),
      ...mapActions(useRouteBirdId, ['setRouterDone']),
      async handleInsertVoucher() {
        if (!this.voucher.trim() || this.voucherValidated) {
          return
        }

        try {
          this.isInputDisabled = true
          this.error = ''
          this.voucherValidated = false
          this.productList = []
          this.selectedProduct = ''

          this.setIsLoading({
            isLoading: true,
            title: 'Aguarde enquanto localizamos seu Voucher/Pedido',
            image: 'zoom',
            message: '',
          })

          const recaptchaToken = await this.oeRecaptcha.getToken('getproduct')

          const response = await loginController.getProductsByVoucher({
            arsubdomain: this.arData.subdomain || '',
            cessToken: this.getCessToken,
            voucher: this.voucher,
            recaptcha_token: recaptchaToken,
          })

          this.productList = response.produtos

          if (this.productList.length > 0) {
            this.voucherValidated = true

            if (this.productList.length === 1) {
              this.selectedProduct =
                this.productList[0].idproduto || this.productList[0].idProduto
            }
          } else {
            this.error = 'Nenhum produto encontrado para este voucher'
          }
        } catch (error: any) {
          this.voucherValidated = false
          this.productList = []

          if (
            error.response &&
            error.response?.data?.message === 'Voucher já utilizado'
          ) {
            this.error = 'Voucher utilizado em outro Certificado'
          } else {
            this.error =
              error.response?.data?.message || 'Voucher ou Pedido inválido.'
          }
        }
      },
      async handleProceed() {
        if (this.isInputDisabled) return

        if (this.voucher.trim() === '') {
          this.error = 'Por favor, insira o código do Voucher/Pedido.'
          return
        }

        if (!this.showProductSelection) {
          await this.handleInsertVoucher()
        }

        if (!this.selectedProduct || !this.voucherValidated) {
          this.isInputDisabled = false

          setTimeout(() => {
            this.setIsLoading({ isLoading: false })
          }, 1500)

          return
        }

        try {
          this.isInputDisabled = true
          this.error = ''
          this.setIsLoading({
            isLoading: true,
            title: 'Aguarde...',
            image: 'zoom',
            message: '',
          })

          this.model = {
            token: this.getCessToken,
            arsubdomain: this.arData.subdomain || '',
            voucher: this.voucher,
          }

          if (this.unidade) {
            this.model.unidade = this.unidade
          }

          const selectedProductFromList = this.productList.find(
            (p: any) =>
              p.idproduto === this.selectedProduct ||
              p.idProduto === this.selectedProduct,
          )

          const isPjProduct =
            selectedProductFromList?.tipo?.toLowerCase() === 'j'

          this.hasProductRFB =
            selectedProductFromList?.politica?.toLowerCase() === 'rfb' || false

          this.model = {
            ...this.model,
            produtos: this.productList
              .filter(
                (product: any) =>
                  product.idproduto === this.selectedProduct ||
                  product.idProduto === this.selectedProduct,
              )
              .map((product: any) => ({
                idproduto: product.idproduto || product.idProduto,
                nome: product.nome,
                idperfiliti: product.idperfiliti || product.idPerfilIti,
              })),
          }

          this.setIsRFB(this.hasProductRFB)

          if (!isPjProduct) {
            await this.createSolicitation(this.model)
            return
          }

          this.model = {
            ...this.model,
            hasRfb: this.hasProductRFB,
          }

          const modal = this.$refs.modalRfbRef as typeof ModalRFB

          setTimeout(() => {
            modal.modalOpen()
          }, 1600)
        } catch (error: any) {
          this.error =
            error.response?.data?.message || 'Erro ao processar certificado.'
        } finally {
          this.isInputDisabled = false
          setTimeout(() => {
            this.setIsLoading({ isLoading: false })
          }, 1500)
        }
      },
      async createSolicitation(request: VoucherParam) {
        try {
          this.isInputDisabled = true
          const modal = this.$refs.modalRfbRef as typeof ModalRFB
          modal.modalClose()
          const arStore = useAR()

          const recaptchaToken = await this.oeRecaptcha.getToken('login')

          const { data } = await loginController.validateVoucher({
            ...request,
            sub: arStore.getSub,
            recaptcha_token: recaptchaToken,
          })

          const payload = {
            ...data,
            voucher: this.voucher,
          }

          saveDataVoucher(payload)
          this.$router.push('/birdId/form')
        } catch (error: any) {
          if (
            error.response &&
            error.response?.data?.message === 'Consulta RFB falhou'
          ) {
            this.error = 'Consulta RFB falhou'
            this.openModalRFBError()
            return
          }
          if (
            error.response &&
            error.response?.data?.message === 'Voucher já utilizado'
          ) {
            this.error = 'Voucher utilizado em outro Certificado'
            return
          }
          this.error = 'Voucher ou Pedido inválido.'
        } finally {
          this.isInputDisabled = false
          setTimeout(() => {
            this.setIsLoading({ isLoading: false })
          }, 1500)
        }
      },
      openModalRFB() {
        const modal = this.$refs.modalRfbRef as typeof ModalRFB
        modal.modalOpen()
      },
      openModalRFBError() {
        const modalerror = this.$refs.modalRfbRefError as typeof ModalRFBError
        modalerror.modalOpen()
      },
    },
    beforeRouteEnter(to, from, next) {
      const solicitation = useSolicitation()
      if (
        !solicitation.getCessToken.sessionData &&
        solicitation.getCessToken.sessionId
      ) {
        return next({ path: '/' })
      }

      return next()
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    beforeRouteLeave() {},
    mounted() {
      this.oeRecaptcha.showBadge()
    },
  })
</script>

<style lang="stylus" scoped>
  @import './style.modules.styl';
</style>

<style>
  .disable-select {
    pointer-events: none;
    opacity: 0.8;
  }

  .disable-select svg {
    pointer-events: none;
    opacity: 0.8;
  }
</style>
